export default `/* Ids Wizard Component */
.ids-wizard {
  padding-inline: var(--ids-space-lg);
  margin-block: var(--ids-space-xs);
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: 100%;
  height: 44px;
}
.ids-wizard .steps {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 24px;
}
.ids-wizard .step.clickable:focus .step-label {
  border: 1px solid var(--ids-wizard-step-color-default);
  border-radius: var(--ids-border-radius-2xs);
  box-shadow: var(--ids-shadow-focus);
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-wizard .step:focus-visible {
  outline-style: none;
}
.ids-wizard .step-label {
  border: 1px solid transparent;
  position: absolute;
  top: var(--ids-space-md);
  box-sizing: border-box;
  text-align: left;
  text-decoration: none;
  padding: 3px 6px;
}
.ids-wizard .step:not(:first-child):not(:last-child) .step-label {
  left: 50%;
  transform: translateX(-50%);
}
.ids-wizard .step:first-child .step-label {
  left: -16px;
}
.ids-wizard .step:last-child .step-label {
  right: -16px;
  text-align: right;
}
.ids-wizard .step:not(.visited) .step-label {
  color: var(--ids-wizard-step-color-unvisited);
}
.ids-wizard .step.visited .step-label {
  color: var(--ids-wizard-step-color-default);
}
.ids-wizard .step:not(.clickable) .step-label {
  cursor: var(--ids-cursor-default);
}
.ids-wizard .step.clickable:not(.current):hover .step-label {
  text-decoration: underline;
}
.ids-wizard .step {
  position: relative;
  text-align: left;
  text-decoration: none;
}
.ids-wizard .step.clickable {
  cursor: var(--ids-cursor-pointer);
}
.ids-wizard .step .step-marker {
  position: relative;
  width: var(--ids-wizard-step-width);
  height: var(--ids-wizard-step-width);
  overflow: visible;
}
.ids-wizard .step .step-marker > svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: visible;
}
.ids-wizard .step .step-marker > svg:nth-child(1) {
  width: var(--ids-wizard-step-width);
  height: var(--ids-wizard-step-width);
  fill: var(--ids-wizard-step-color-default);
  stroke: none;
  z-index: 2;
}
.ids-wizard .step .step-marker > svg:nth-child(2) {
  width: calc(var(--ids-wizard-step-width) + 5px);
  height: calc(var(--ids-wizard-step-width) + 5px);
  fill: var(--ids-wizard-step-inner-border-color-border);
  stroke: var(--ids-wizard-step-color-default);
  stroke-width: 1px;
  z-index: 1;
}
.ids-wizard .path-segment {
  position: relative;
  height: 100%;
  flex-grow: 1;
}
.ids-wizard .path-segment::before {
  background-color: var(--ids-wizard-step-color-unvisited);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 2px;
  content: "";
}
.ids-wizard .path-segment.visited::before {
  background-color: var(--ids-wizard-step-color-default);
}
.ids-wizard .path-segment.from-prev {
  left: 0;
}
.ids-wizard .path-segment.to-next {
  right: 0;
}
.ids-wizard .step.current .step-label {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-wizard .step:not(.visited) svg:first-child circle {
  fill: var(--ids-color-transparent);
  stroke: var(--ids-wizard-step-color-unvisited);
  stroke-width: 3px;
}
.ids-wizard .step.disabled:not(.visited) svg:first-child circle {
  fill: none;
  stroke: var(--ids-wizard-step-color-disabled-unvisited);
  stroke-width: 3px;
}
.ids-wizard .step.disabled.visited svg:first-child circle {
  fill: var(--ids-wizard-step-color-disabled);
  stroke: none;
  stroke-width: none;
}
.ids-wizard .step.disabled.visited .step-label ids-text::part(text) {
  color: var(--ids-wizard-step-color-disabled);
}
.ids-wizard slot {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
